import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { ZodObject, ZodRawShape } from 'zod';

import { PaymentProviderName } from 'domain/paySettings/helpers';

import { globalAccountsConfig } from '../config';

import { FieldConfig } from '../types';

export const buildUpdateSchema = <T extends ZodRawShape>(schema: ZodObject<T>, fields: FieldConfig[]) => {
  const editableNames = fields.filter((field) => field.editable).map((field) => field.name) as (keyof T)[];

  return schema.pick(
    editableNames.reduce((acc, key) => {
      // @ts-ignore
      acc[key] = true;
      return acc;
    }, {}),
  );
};

const useProviderForm = (provider: PaymentProviderName, defaultValues = {}, isEdit = false) => {
  const config = globalAccountsConfig[provider];

  const schema = isEdit ? buildUpdateSchema(config.schema, config.fields) : config.schema;

  return useForm({
    resolver: zodResolver(schema),
    mode: 'onChange',
    defaultValues,
  });
};

export default useProviderForm;
